/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { useAppSelector } from '../../../../infra/hooks';
import DTOInsuranceList from './DTOInsuranceList';
import InsuranceListPresenter from './InsuranceListPresenter';
import { useTranslation } from 'react-i18next';

function InsuranceListController() {
  const [allInsuranceData, setAllInsuranceData] = useState([]);
  const { t } = useTranslation();

  const isLoading = useAppSelector(
    (state) => state.insuranceListSlice.insuranceListLoader,
  );

  function callBackFunc(data: any) {
    setAllInsuranceData(data);
  }

  const hr_view = useAppSelector((state) => state.isHRViewSlice.HRView);

  return (
    <>
      <DTOInsuranceList setInsuranceListData={callBackFunc} />
      <InsuranceListPresenter
        insuranceData={allInsuranceData}
        isLoading={isLoading}
        hr_view={hr_view}
        trans={t}
      />
    </>
  );
}

export default InsuranceListController;
